import { h } from "preact"
import { StyledDivider } from "./styled"

interface IDevider {
    type?: string;
}

const ComponentDivider = ({ type }: IDevider) => {
    return <StyledDivider type={type}></StyledDivider>

}

export default ComponentDivider;